
import { Reducer } from "redux";
import { TransactionState } from "../types";
import { evaluatePosition, getBatteryForRange, getSignalForRange, getTransactions } from "../routines";
import { TransactionLogActionTypes } from "../actionTypes";
import moment from "moment";
import { TransactionEventFilterEnum } from "@Safemate/TransactionLog/TransactionEnum";

const transactionState: TransactionState = {
    transactions: [],
    filter: [
      TransactionEventFilterEnum.ALARM,
      TransactionEventFilterEnum.BATTERY,
      TransactionEventFilterEnum.FAILED_SELFCHECK,
      TransactionEventFilterEnum.GEOFENCE,
      TransactionEventFilterEnum.DEVICE_STATE,
      TransactionEventFilterEnum.POSITION
    ],
    fromDate: moment(new Date()).startOf("day"),
    toDate: moment(new Date()).endOf("day"),
    page: 1,
    lastUpdate: Date.now(),
    details: false,
    showPosition: false,
    battery: [],
    signal: [],
    loadingBatteryData: false,
    loadingSignalData: false,
    loadedSignalData: false,
    loadedBatteryData: false
};

const transaction: Reducer<TransactionState> = (state: TransactionState = transactionState, action) => {
  switch (action.type) {
    case getTransactions.SUCCESS:
        return {
            ...state,
            ...action.payload
        }

    case evaluatePosition.SUCCESS:
        return {
            ...state,
            transactions: action.payload
        }

    case TransactionLogActionTypes.SET_FILTER:
        return {
            ...state,
            page: 1,
            filter: action.payload,
        }

    case TransactionLogActionTypes.SET_DATE:
        return{
            ...state,
            page: 1,
            ...action.payload
        }

    case TransactionLogActionTypes.SET_PAGE:
        return{
            ...state,
            page: action.payload
        }

    case TransactionLogActionTypes.SET_DETAILS:
        return{
            ...state,
            details: action.payload
        }

    case TransactionLogActionTypes.SET_SHOW_POSITION:
      return{
        ...state,
        showPosition: action.payload
      }

    case TransactionLogActionTypes.RESET_STATE:
        return transactionState;

    case getBatteryForRange.TRIGGER:{
      return {
        ...state,
        loadingBatteryData: true
      }
    }

    case getSignalForRange.TRIGGER:{
      return {
        ...state,
        loadingSignalData: true
      }
    }

    case getBatteryForRange.SUCCESS:{
      return {
        ...state,
        battery: action.payload,
        loadedBatteryData: true,
      }
    }

    case getSignalForRange.SUCCESS:{
      return {
        ...state,
        signal: action.payload,
        loadedSignalData: true
      }
    }

    case getBatteryForRange.FULFILL:{
      return {
        ...state,
        loadingBatteryData: false
      }
    }

    case getSignalForRange.FULFILL:{
      return {
        ...state,
        loadingSignalData: false
      }
    }

    default:
        return state;
    }
}

export default transaction;
